import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=447c273c&"
import script from "./ChatRoom.vue?vue&type=script&lang=js&"
export * from "./ChatRoom.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports